// extracted by css-extract-rspack-plugin
export default {"actionWrapper":"MenuActions_actionWrapper__tgYH6","name":"MenuActions_name__OKBsx"};